import { RBAClient } from 'rba-client'
const client = RBAClient.getInstance(require('@/api/config'))

// initial state
const state = {
  listing: {
    requestTimeout: null,
    requestLoading: false,
    columns: [
      'guid',
      'url',
      'eventTypes',
      // 'createdDatetime',
      // 'modifiedDatetime',
      'action'
    ],
    options: {
      initFilters: [],
      initialPage: 1,
      perPage: 10,
      orderBy: {
        ascending: true,
        column: null
      },
      async requestFunction () {
        // clearTimeout(this.requestTimeout)
        try {
          return await new Promise((resolve, reject) => {
            if (this.$store) {
              this.$store.commit('ongoing/ongoingTable', { requestLoading: true })
            }
            client.ongoing
              .findWhere()
              .then((results) => {
                console.log(results)
                resolve({ data: results.data.ongoings, count: results.data.ongoings.length })
              })
              .catch((error) => {
                reject(error)
              })
          })
        } catch (e) {
          this.dispatch('error', e)
        }
      },
      /* responseAdapter: function(resp) {
        // console.log('responseAdapter', resp);
        return { data: resp.data[0], count: resp.data[1] };
      }, */
      columnsClasses: {
        guid: 'col-xs-2',
        eventTypes: 'col-xs-2',
        action: 'col-xs-1'
      },
      sortable: [],
      filterable: false, // []
      filterByColumn: true,
      dateColumns: ['createdDatetime', 'modifiedDatetime'],
      dateFormat: 'DD/MMM/YYYY'
    }
  },
  event_types: []
}

// getters
const getters = {
  options (state, unusedGetters, unusedRootState, rootGetters) {
    // rootGetters.i18n.t()
    // console.log('this', this)
    // console.log('rootGetters', rootGetters)
    const { i18n } = rootGetters
    const { initFilters, initialPage, perPage, orderBy, requestFunction, columnsClasses, sortable, filterable, filterByColumn, dateColumns } = state.listing.options

    return {
      initFilters,
      initialPage,
      perPage,
      orderBy,
      requestFunction,
      columnsClasses,
      sortable,
      headings: {
        guid: i18n.t('ongoing.listing.table.guid.label'),
        url: i18n.t('ongoing.details.form.url.label'),
        eventTypes: i18n.t('ongoing.details.form.eventTypes.label'),
        action: i18n.t('listing.table.action.label')
      },
      filterable,
      filterByColumn,
      dateColumns,
      texts: {
        count: i18n.t('listing.table.texts.count'),
        first: i18n.t('listing.table.texts.first'),
        last: i18n.t('listing.table.texts.last'),
        filter: i18n.t('listing.table.texts.filter'),
        filterPlaceholder: i18n.t('listing.table.texts.filterPlaceholder'),
        limit: i18n.t('listing.table.texts.limit'),
        page: i18n.t('listing.table.texts.page'),
        noResults: i18n.t('listing.table.texts.noResults'),
        noRequest: i18n.t('listing.table.texts.noRequest'),
        filterBy: i18n.t('listing.table.texts.filterBy'),
        loading: i18n.t('listing.table.texts.loading'),
        defaultOption: i18n.t('listing.table.texts.defaultOption'),
        columns: i18n.t('listing.table.texts.columns')
      }
    }
  }
}

// actions
const actions = {
  findWhere (_, payload) {
    return client.ongoing.list(...payload)
  },
  start (_, payload) {
    console.log(payload)
    return client.ongoing.start(payload)
  },
  stop (_, { taskId }) {
    return client.ongoing.cancel({ taskId })
  },
  retryImport (_, { taskId }) {
    return client.ongoing.reloadResult({ taskId })
  },
  async info () {
    var lastFullScreening = (await client.action_log.findWhere({
      where: {
        type: 'ongoing_screening.task.start',
        data: {
          $Contains: '"batchType":"all"'
        }
      },
      sort: 'create_date DESC',
      limit: 10
    })).data[0]
    var lastDeltaScreening = (await client.action_log.findWhere({
      where: {
        type: 'ongoing_screening.task.start',
        data: {
          $Contains: '"batchType":"all_new"'
        }
      },
      sort: 'create_date DESC',
      limit: 10
    })).data[0]
    return {
      lastFullScreening,
      lastDeltaScreening
    }
  },
  ongoingScreeningEWE (_, { entityType, refId }) {
    return client.ongoing.ongoingScreeningSingle({
      entityType,
      refId
    })
  }
}

// mutations
const mutations = {
  // SET_RECORDS (state, payload) {
  //   state.records = payload
  // },
  // SET_SORT_COLUMN (state, payload) {
  //   state.orderby = payload
  // },
  // SET_SORT_DIRECTION (state, payload) {
  //   state.order = payload
  // },
  // SET_PAGE_NUM (state, payload) {
  //   state.page_num = payload
  // },
  'ongoingTable/SET_DATA' (state, data) {
    console.log('ongoingTable/SET_DATA', data)
  },
  'ongoingTable/PAGINATION' (state, data) {
    console.log('ongoingTable/PAGINATION', data)
  },
  'ongoingTable/FILTER' (state, data) {
    console.log('ongoingTable/FILTER', data)
  },
  'ongoingTable/SORTED' (state, data) {
    console.log('ongoingTable/SORTED', data)
  },
  'ongoingTable/LOADING' (state, payload) {
    console.log('ongoingTable/LOADING', payload)
    state.listing.options.initFilters = payload.query
    state.listing.options.initialPage = payload.page
    state.listing.options.perPage = payload.limit
    state.listing.options.orderBy.ascending = payload.ascending
    state.listing.options.orderBy.column = payload.orderBy
    // state.listing.requestLoading = true
  },
  'ongoingTable/LOADED' (state, data) {
    console.log('ongoingTable/LOADED', data)
    state.listing.requestLoading = false
  },
  'ongoingTable/LIMIT' (state, data) {
    console.log('ongoingTable/LIMIT', data)
  },
  'ongoingTable/ERROR' (state, data) {
    console.log('ongoingTable/ERROR', data)
    state.listing.requestLoading = false
  },
  'ongoingTable/ROW_CLICK' (state, data) {
    console.log('ongoingTable/ROW_CLICK', data)
  },
  'ongoingTable' (state, { requestLoading }) {
    state.listing.requestLoading = requestLoading === undefined ? state.listing.requestLoading : requestLoading
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
